import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { AddMaterials } from "./dialog/AddMaterials";
import { useForm } from "react-hook-form";

export const Materials = () => {
    const { getValues, 
            setValue, 
            control,
            clearErrors, 
            register, 
            handleSubmit, 
            formState: { errors,isValid } } = useForm({
        defaultValues: {
         
        },
         //錯誤驗證時機
        mode: "all"
      })
    const [addDialog,setAddDialog] = useState(false);
    const { t } = useTranslation();
    const fileInputRef = useRef(null);

    const actionBodyTemplate = ()=>{
        return(
            <>
            <Button
                rounded text severity="secondary"
                className="p-button-icon-only"
                tooltip={t('button.edit')}
            >
                <FontAwesomeIcon icon="fa-solid fa-edit" />
            </Button>
            <Button
                rounded text severity="secondary"
                className="p-button-icon-only"
                tooltip={t('button.copy')}
            >
                <FontAwesomeIcon icon="fa-solid fa-copy" />
            </Button>
            <Button
                rounded text severity="danger"
                className="p-button-icon-only"
                tooltip={t('button.delete')}
            >
                <FontAwesomeIcon icon="fa-solid fa-trash-can" />
            </Button>
            </>
        )
    }
    const orderNoTemplate = (data, props) => {
        return (
            <span>
                {props.rowIndex + 1}
            </span>
        )
    }
    let tableDate=[
        {type:'主要原物料',name:'A.原物料',inputRatio:'100',value:'100kg',attached:'',remark:''},
        {type:'輔助物料',name:'B.輔助料',inputRatio:'80',value:'55ml',attached:'',remark:''},
        {type:'水資源投入',name:'自來水',inputRatio:'50',value:'2000L',attached:'',remark:''},
    ]
    
    return(<>
        <Button className="mb-2" label="新增" onClick={()=>setAddDialog(true)}></Button>
        
        <DataTable 
            stripedRows
            value={tableDate} 
            tableStyle={{ minWidth: '50rem' }}
        >
            <Column body={orderNoTemplate} header={t('itemNo')}></Column>
            <Column field="type" header="種類"></Column>
            <Column field="name" header="名稱"></Column>
            <Column field="inputRatio" header="投入比(%)"></Column>
            <Column field="value" header="數值"></Column>
            <Column field="attached" header={`${t('attached_picture')}/${t('attachments')}`}></Column>
            <Column field="remark" header={t('remark')}></Column>
            <Column body={actionBodyTemplate} header={t('action')}></Column>
        </DataTable>

        <PrimeDialog
        visible={addDialog}
            title="新增"
            size="lg"
            onClose={() => { setAddDialog(false) }}
            onConfirm={() => { setAddDialog(false) }}
            bodyTemplate={
            <AddMaterials
                register = {register}
                errors = {errors}
                control = {control}
                setValue = {setValue}
                fileInputRef={fileInputRef}
            ></AddMaterials>}
        ></PrimeDialog>
    </>)
}